const AddressTypes = {
    Current: "Current",
    Previous: "Previous",
    Billing: "Billing",
    Mailing: "Mailing",
    Headquarters: "Headquarters",
    Workplace: "Workplace"
}

export default AddressTypes;
